import { useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getBulkCapabilityValues } from 'services/CapabilitiesService'
import { BulkCapabilityRequest, BulkCapabilityResponse } from 'types/capabilities/capabilities'
import { QueryMetaType } from 'types/reactQuery'

export const useBulkCapabiltiesQuery = (
  request?: BulkCapabilityRequest,
  isEnabled = false,
  queryHash?: string
) => {
  const meta: QueryMetaType = {
    errorAdditionalData: request,
    excludedErrorCodes: [404],
  }

  const isQueryEnabled = isEnabled && !!request

  return useQuery({
    queryKey: reactQueryKeys.bulkCapabilities(request, queryHash),
    queryFn: async () => {
      if (!request) {
        return undefined
      }
      const data = await getBulkCapabilityValues(request)
      if (data) {
        return data
      }
      return {} as BulkCapabilityResponse
    },
    enabled: isQueryEnabled,
    meta,
    ...(queryHash && { queryHash }),
  })
}
